import { createSlice } from "@reduxjs/toolkit";
import { asyncLogout, wrongAuthToken } from "./auth";

import Api from "../api/Api";

type State = {
  isLoading: boolean;
  error: Object | null;
  data: any;
};

const INITIAL_STATE = {
  isLoading: true,
  error: null,
  data: {},
};

const currentBrand = createSlice({
  name: "currentBrand",
  initialState: INITIAL_STATE,
  reducers: {
    fetchCurrentBrandStart: (state: State) => {
      state.isLoading = true;
    },
    fetchCurrentBrandSuccess: (state: State, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    updateCurrentBrandFields: (state: State, action) => {
      const updatedFields = action.payload;
      if (!state.data || !state.data.id || state.data.id.value !== updatedFields.id.value) {
        return;
      }
      state.data = { ...state.data, ...updatedFields };
    },
    clearCurrentBrand: () => INITIAL_STATE,
  },
});

export default currentBrand.reducer;

const { fetchCurrentBrandStart, fetchCurrentBrandSuccess, updateCurrentBrandFields, clearCurrentBrand } = currentBrand.actions;

export { updateCurrentBrandFields };

export const fetchCurrentBrand = (authToken?: string, navigate?: Function) => async (dispatch: Function) => {
  try {
    dispatch(fetchCurrentBrandStart());
    const api = new Api();
    const result = await api.getCurrentBrand(authToken);

    if (result.hasOwnProperty('loggedin') && !result.loggedin) {
      if (authToken) {
        dispatch(wrongAuthToken())
      } else {
        dispatch(asyncLogout());
      }
    } else {
      // Don't call loginViaAuthToken when using auth param - we want to stay in UnAuthRoutes
      // if (authToken) {
      //   console.log('Calling loginViaAuthToken with:', authToken);
      //   dispatch(loginViaAuthToken(authToken));
      // }
      dispatch(fetchCurrentBrandSuccess(result));
    }
  } catch (err : any) {
    if (authToken && err.response?.status === 401) {
      dispatch(wrongAuthToken())
    } else {
      dispatch(asyncLogout());
    }
  }
};

export const clearCurrentBrandInfo = () => async (dispatch: Function) => {
  dispatch(clearCurrentBrand());
};